import { get, post } from '@http/request'
/**
 * 国际件api
 * international
 */

// 下载模板
export const downloadTemplateNew = (params) => post(`/vip/excel/international/downloadTemplate`, params, { responseType: 'blob' })

// 下单
export const batchAdd = (params) => post(`/vip/order/international/batchAdd`, params)

// 打印
export const printOrders = (reqData) => post(`/vip/order/international/printOrder`, reqData)

// 导出
export const asyExportOrder = (reqData) => post(`/vip/order/international/asyExportOrder`, reqData)

// 获取所有国家列表
export const getCountry = (params) => get(`/vip/area/getCountry`, params)

// 订单列表
export const orderList = (reqData) => post(`/vip/order/international/list`, reqData)

// 订单：订单状态分组统计总数
export const orderTotalGroup = (reqData) => post(`/vip/order/international/totalGroup`, reqData)
